import {
    LOGIN    
} from "./actionTypes";


/**
 * Creates a login action object with the provided data, success callback, and failure callback.
 * @param {any} data - The data to be included in the payload of the action.
 * @param {function} success - The callback function to be executed upon successful login.
 * @param {function} failure - The callback function to be executed upon failed login.
 * @returns {object} - The login action object.
 */
export const login = (data, success, failure) => {
 
  return {
    type: LOGIN,
    payload: { data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}


